import { CustomersTableRow } from '../../models/customer.models';
import { DocumentTableRow, FolderTableRow } from '../../models/documentHub';

export type Order = 'asc' | 'desc';

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<
  Key extends
    | keyof FolderTableRow
    | keyof DocumentTableRow
    | keyof CustomersTableRow,
>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: string | DocumentTableRow[] | boolean },
  b: { [key in Key]: string | DocumentTableRow[] | boolean }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export const getAllDocuments = (
  folders: FolderTableRow[] | undefined,
  folderType: string
) => {
  if (!folders) {
    return [];
  }
  if (folderType === 'All') {
    return folders.flatMap((folder) => folder.documents);
  } else {
    return folders
      .filter((folder) => folder.folderKey === folderType)
      .flatMap((folder) => folder.documents);
  }
};

export const getUnreadDocumentCount = (folders: FolderTableRow[]) => {
  if (folders) {
    const allDocuments = getAllDocuments(folders, 'All');
    const unreadDocuments = allDocuments.filter(
      (doc) => doc.hasBeenViewed === false
    );
    return unreadDocuments.length;
  }
};
